<template>
  <DatasheetForm
    :is-submit-button="true"
  />
</template>
<script type="text/javascript">
import DatasheetForm from './Form.vue';

export default {
  components: {
    DatasheetForm,
  },
}
</script>